import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { EntityAvatar } from "@components/avatar/EntityAvatar";
import { useIdCopy } from "@hooks/useIdCopy";
import { ClientsCloseOverviewRow } from "../clientsCloseOverviewViewConfig";
import styles from "./ClientNameCell.module.scss";

export const ClientNameCell = memo(
    ({
        row,
    }: CellContext<ViewTableFeatures, ClientsCloseOverviewRow, string>) => {
        const { rowType, name, entityId, iconColor, logo } = row.original;
        const rowTypeLabels = {
            entity: "Entity",
            workspace: "Workspace",
        } as const;
        const { getCopyProps } = useIdCopy({
            label: rowTypeLabels[rowType],
        });

        const copyId =
            rowType === "entity"
                ? entityId
                : row.original.id.replace(/^(workspace|entity):/, "");

        if (rowType === "entity") {
            return (
                <div className={styles.entityName}>
                    <EntityAvatar
                        size="xs"
                        entity={{
                            name,
                            iconColor: iconColor ?? "",
                            logo: logo ?? null,
                        }}
                        aria-hidden
                    />
                    <span className={styles.nameText} {...getCopyProps(copyId)}>
                        {name}
                    </span>
                </div>
            );
        }

        return (
            <span className={styles.nameText} {...getCopyProps(copyId)}>
                {name}
            </span>
        );
    },
);

ClientNameCell.displayName = "ClientNameCell";
